import {Component, Inject, OnInit} from '@angular/core';
import {MD_DIALOG_DATA, MdDialog, MdDialogConfig, MdDialogRef} from '@angular/material';
import {TemplateColumnEditorDialogParameters} from './TemplateColumnEditorDialogParameters';
import {ReportTemplateColumn} from '../../interfaces/ReportTemplateColumn';
import {FieldSelectorDialogComponent} from '../../../form-builder/components/field-selector-dialog/field-selector-dialog.component';
import {FieldSelectorDialogResult} from '../../../form-builder/components/field-selector-dialog/FieldSelectorDialogResult';
import {ReportFormulaTestService} from '../../services/report-formula-test/report-formula-test.service';
import {EFieldType} from '../../../form-builder/enums/e-field-type.enum';

@Component({
  selector: 'app-template-column-editor-dialog',
  templateUrl: './template-column-editor-dialog.component.html',
  styleUrls: ['./template-column-editor-dialog.component.scss']
})
export class TemplateColumnEditorDialogComponent implements OnInit {

  public reportTemplateColumn: ReportTemplateColumn;
  public status = null;
  public waitingOnTest = false;
  constructor(public dialogRef: MdDialogRef<TemplateColumnEditorDialogComponent>,
              @Inject(MD_DIALOG_DATA) public data: TemplateColumnEditorDialogParameters,
              public dialog: MdDialog,
              public reportFormulaTestService: ReportFormulaTestService) { }


  ngOnInit() {
    if (this.data.reportTemplateColumn) {
      this.reportTemplateColumn = this.data.reportTemplateColumn;
    } else {
      this.reportTemplateColumn = {
        name: '',
        description: '',
        formula: '',
        report_template_id: this.data.reportTemplateId,
        report_template_fields: []
      }
    }
  }

  public testFormula() {
    this.waitingOnTest = true;
    this.reportFormulaTestService.testColumn(this.reportTemplateColumn).then(() => {
      this.waitingOnTest = false;
      this.status = 'success';
    }).catch(() => {
      this.waitingOnTest = false;
      this.status = 'fail'
    });
  }


  newField() {
    this.dialog
      .open(FieldSelectorDialogComponent, {data: {}})
      .afterClosed().subscribe((result?: FieldSelectorDialogResult) => {
       if (result) {
         const field = result.field;
         this.reportTemplateColumn.report_template_fields.push({
           where_statements: [],
           letter: '',
           field: field,
           field_group_id: result.fieldGroup
         })
       }

    });
  }

  removeField(index) {
    this.reportTemplateColumn.report_template_fields =
      this.reportTemplateColumn.report_template_fields.filter((item, i) => i !== index);
  }

  public canSave() {
    return this.status === 'success';
  }

  public save() {
    this.dialogRef.close(this.reportTemplateColumn);
  }

  public cancel() {
    this.dialogRef.close();
  }

  public changed() {
    this.status = null;
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/report/components/template-column-editor-dialog/template-column-editor-dialog.component.ts